(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ir-v5-collection-root]';
  var HOVER_CARD_SELECTOR = '[data-ir-collection-hover-card]';
  var HOVER_IMAGE_SELECTOR = '[data-ir-collection-hover-image]';
  var FINE_HOVER_QUERY = '(hover: hover) and (pointer: fine)';
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function findSidebarSection(mainSection) {
    var sibling = mainSection ? mainSection.previousElementSibling : null;

    while (sibling) {
      if (sibling.matches('.t4s-section-sidebar')) return sibling;
      sibling = sibling.previousElementSibling;
    }

    return document.querySelector('.t4s-section-sidebar');
  }

  function cloneSidebarContent(template) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ir-v5-sidebar-content';

    if (!template || !template.content) return wrapper;

    var inner = template.content.querySelector('.t4s-sidebar-inner');
    var clear = template.content.querySelector('.clear-filter');

    if (inner) wrapper.appendChild(inner.cloneNode(true));
    if (clear) wrapper.appendChild(clear.cloneNode(true));

    wrapper.querySelectorAll('[data-replace-filter]').forEach(function (placeholder) {
      if (!placeholder.children.length && !placeholder.textContent.trim()) {
        placeholder.remove();
      }
    });

    return wrapper;
  }

  function hasSidebarContent(content) {
    return Boolean(content.querySelector('.t4s-widget:not([data-replace-filter])'));
  }

  function createDrawer(root, template) {
    var drawer = document.createElement('div');
    var overlay = document.createElement('button');
    var panel = document.createElement('div');
    var header = document.createElement('div');
    var title = document.createElement('h2');
    var closeButton = document.createElement('button');
    var body = document.createElement('div');
    var sectionId = (root.dataset.irSectionId || 'collection').replace(/[^a-zA-Z0-9_-]/g, '-');
    var drawerId = 'ir-v5-sidebar-drawer-' + sectionId;
    var closeLabel = root.dataset.irCloseLabel || 'Close';
    var lastTrigger = null;
    var closeTimer = null;

    drawer.className = 'ir-v5-sidebar-drawer';
    drawer.id = drawerId;
    drawer.hidden = true;

    overlay.className = 'ir-v5-sidebar-drawer__overlay';
    overlay.type = 'button';
    overlay.setAttribute('aria-label', closeLabel);

    panel.className = 'ir-v5-sidebar-drawer__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', drawerId + '-title');

    header.className = 'ir-v5-sidebar-drawer__header';
    title.className = 'ir-v5-sidebar-drawer__title';
    title.id = drawerId + '-title';
    title.textContent = root.dataset.irSidebarTitle || 'Filters';

    closeButton.className = 'ir-v5-sidebar-drawer__close';
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', closeLabel);
    closeButton.textContent = '\u00d7';

    body.className = 'ir-v5-sidebar-drawer__body';
    body.appendChild(cloneSidebarContent(template));
    body.querySelectorAll('[id]').forEach(function (element) {
      element.id = drawerId + '-' + element.id;
    });

    header.appendChild(title);
    header.appendChild(closeButton);
    panel.appendChild(header);
    panel.appendChild(body);
    drawer.appendChild(overlay);
    drawer.appendChild(panel);
    document.body.appendChild(drawer);

    function open(trigger) {
      if (closeTimer) window.clearTimeout(closeTimer);
      lastTrigger = trigger || null;
      drawer.hidden = false;
      document.body.classList.add('ir-v5-sidebar-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        closeButton.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('ir-v5-sidebar-drawer-open');
      closeTimer = window.setTimeout(function () {
        drawer.hidden = true;
        if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      }, 210);
    }

    overlay.addEventListener('click', close);
    closeButton.addEventListener('click', close);
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    return { element: drawer, id: drawerId, open: open, close: close };
  }

  function setupSort(root) {
    var openButton = root.querySelector('[data-dropdown-open]');
    var wrapper = root.querySelector('[data-dropdown-wrapper]');
    var closeButton = root.querySelector('[data-dropdown-close]');

    if (!openButton || !wrapper) return;

    function close() {
      wrapper.classList.remove('is--opened');
      openButton.classList.remove('is--clicked');
      openButton.setAttribute('aria-expanded', 'false');
    }

    function open() {
      wrapper.classList.add('is--opened');
      openButton.classList.add('is--clicked');
      openButton.setAttribute('aria-expanded', 'true');
    }

    openButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (wrapper.classList.contains('is--opened')) close();
      else open();
    });

    if (closeButton) closeButton.addEventListener('click', close);

    wrapper.querySelectorAll('[data-sortby-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', item.dataset.value || 'manual');
        nextUrl.searchParams.delete('page');
        window.location.assign(nextUrl.toString());
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        openButton.focus();
      }
    });
  }

  function setupSidebar(root) {
    var mainSection = root.closest('.t4s-section-main');
    var sidebarSection = findSidebarSection(mainSection);
    var template = sidebarSection && sidebarSection.querySelector('[data-ir-v5-sidebar-template]');
    var sidebarTarget = root.querySelector('[data-sidebar-content]');
    var content = cloneSidebarContent(template);
    var hasContent = hasSidebarContent(content);
    var drawer = null;

    if (!mainSection || !sidebarTarget || !sidebarSection || !template || !hasContent) {
      if (mainSection) {
        mainSection.classList.remove('ir-v5-sidebar-ready');
        mainSection.classList.add('ir-v5-sidebar-empty');
      }
      if (sidebarTarget) sidebarTarget.hidden = true;
      root.querySelectorAll('[data-ir-sidebar-open]').forEach(function (trigger) {
        trigger.hidden = true;
      });
      return;
    }

    sidebarTarget.replaceChildren(content);
    sidebarTarget.hidden = false;
    sidebarTarget.classList.remove('t4s-dn');
    mainSection.classList.remove('ir-v5-sidebar-empty');
    mainSection.classList.add('ir-v5-sidebar-ready');

    drawer = createDrawer(root, template);

    Array.prototype.slice.call(root.querySelectorAll('[data-ir-sidebar-open]'))
      .concat(Array.prototype.slice.call(sidebarSection.querySelectorAll('[data-ir-sidebar-open]')))
      .forEach(function (trigger) {
        trigger.hidden = false;
        trigger.setAttribute('aria-controls', drawer.id);
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          drawer.open(trigger);
        });
      });
  }

  function setLoadMoreLoading(link, loading) {
    var spinner = link.querySelector('.t4s-loading__spinner');

    link.classList.toggle('is--loading', loading);

    if (loading) {
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');
    } else {
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
    }

    if (spinner) spinner.classList.toggle('t4s-dn', !loading);
  }

  function canLoadCollectionHoverImage(event) {
    if (typeof window.matchMedia !== 'function') return false;
    if (!window.matchMedia(FINE_HOVER_QUERY).matches) return false;
    if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return false;

    return !event.pointerType || event.pointerType !== 'touch';
  }

  function loadCollectionHoverImage(image) {
    if (!image || image.dataset.irHoverState) return;

    var src = image.dataset.irHoverSrc;
    var srcset = image.dataset.irHoverSrcset;

    if (!src || !srcset) return;

    image.dataset.irHoverState = 'loading';

    function markReady() {
      if (image.dataset.irHoverState !== 'loading') return;

      image.dataset.irHoverState = 'decoding';

      var decodeResult;

      try {
        decodeResult = typeof image.decode === 'function' ? image.decode() : null;
      } catch (error) {
        decodeResult = null;
      }

      Promise.resolve(decodeResult)
        .catch(function () {})
        .then(function () {
          if (image.dataset.irHoverState === 'decoding') {
            image.dataset.irHoverState = 'ready';
          }
        });
    }

    function markFailed() {
      if (
        image.dataset.irHoverState === 'loading' ||
        image.dataset.irHoverState === 'decoding'
      ) {
        image.dataset.irHoverState = 'error';
      }
    }

    image.addEventListener('load', markReady, { once: true });
    image.addEventListener('error', markFailed, { once: true });
    image.sizes = image.dataset.irHoverSizes || 'auto';
    image.srcset = srcset;
    image.src = src;

    if (image.complete && image.naturalWidth > 0) markReady();
  }

  function setupCollectionHoverImages(root) {
    root.addEventListener('pointerover', function (event) {
      if (!canLoadCollectionHoverImage(event)) return;

      var target = event.target;
      var card = target && target.closest && target.closest(HOVER_CARD_SELECTOR);

      if (!card || !root.contains(card)) return;

      loadCollectionHoverImage(card.querySelector(HOVER_IMAGE_SELECTOR));
    });
  }

  function appendLoadMorePage(root, responseText) {
    var parsed = new DOMParser().parseFromString(responseText, 'text/html');
    var nextRoot = parsed.querySelector(ROOT_SELECTOR);
    var currentContent = root.querySelector('[data-contentlm-replace]');
    var nextContent = nextRoot && nextRoot.querySelector('[data-contentlm-replace]');
    var currentPagination = root.querySelector('[data-wrap-lm]');
    var nextPagination = nextRoot && nextRoot.querySelector('[data-wrap-lm]');
    var nextItems = nextContent ? Array.prototype.slice.call(nextContent.children) : [];

    if (!currentContent || !currentPagination || !nextRoot || !nextContent || !nextItems.length) {
      throw new Error('Invalid collection Load More response');
    }

    nextItems.forEach(function (item) {
      currentContent.appendChild(item);
    });

    if (currentPagination) {
      if (nextPagination) {
        currentPagination.replaceWith(nextPagination);
      } else {
        var currentFooter = currentPagination.closest('.t4s-prs-footer');
        if (currentFooter) currentFooter.remove();
        else currentPagination.remove();
      }
    }

    return nextItems.length;
  }

  function setupLoadMore(root) {
    var infiniteObserver = null;
    var observedInfiniteLink = null;
    var autoLoadFrame = null;

    function findInfiniteLink() {
      return root.querySelector(
        '[data-load-more][data-load-onscroll]:not([data-is-prev])'
      );
    }

    function maybeAutoLoad() {
      autoLoadFrame = null;

      var link = findInfiniteLink();
      if (!link || link.dataset.irV5LoadMoreLoading === 'true') return;

      var rect = link.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 480 && rect.bottom >= -480) {
        link.click();
      }
    }

    function queueAutoLoad() {
      if (autoLoadFrame !== null) return;
      autoLoadFrame = window.requestAnimationFrame(maybeAutoLoad);
    }

    function observeInfiniteLink() {
      var nextLink = findInfiniteLink();

      if (typeof window.IntersectionObserver === 'function') {
        if (!nextLink && !infiniteObserver) return;

        if (!infiniteObserver) {
          infiniteObserver = new window.IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var link = entry.target;

                if (
                  !entry.isIntersecting ||
                  link !== observedInfiniteLink ||
                  !root.contains(link) ||
                  link.dataset.irV5LoadMoreLoading === 'true'
                ) {
                  return;
                }

                infiniteObserver.unobserve(link);
                observedInfiniteLink = null;
                link.click();
              });
            },
            { root: null, rootMargin: '480px 0px', threshold: 0 }
          );
        }

        if (nextLink !== observedInfiniteLink) {
          if (observedInfiniteLink) infiniteObserver.unobserve(observedInfiniteLink);
          observedInfiniteLink = nextLink;

          if (observedInfiniteLink) infiniteObserver.observe(observedInfiniteLink);
        }
      }

      root.dataset.irV5InfiniteReady = 'true';
      queueAutoLoad();
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-load-more]:not([data-is-prev])');

      if (
        !target ||
        !root.contains(target) ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var nextUrl = target.href;
      var requestUrl = new URL(nextUrl, window.location.origin);

      if (requestUrl.origin !== window.location.origin) return;

      event.preventDefault();

      if (target.dataset.irV5LoadMoreLoading === 'true') return;

      requestUrl.searchParams.set('section_id', root.dataset.irSectionId);
      target.dataset.irV5LoadMoreLoading = 'true';
      setLoadMoreLoading(target, true);

      fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Collection Load More request failed');
          return response.text();
        })
        .then(function (responseText) {
          var addedCount = appendLoadMorePage(root, responseText);
          observeInfiniteLink();
          if (
            window.lazySizesT4 &&
            window.lazySizesT4.autoSizer &&
            typeof window.lazySizesT4.autoSizer.checkElems === 'function'
          ) {
            window.lazySizesT4.autoSizer.checkElems();
          }
          if (
            window.lazySizesT4 &&
            window.lazySizesT4.loader &&
            typeof window.lazySizesT4.loader.checkElems === 'function'
          ) {
            window.lazySizesT4.loader.checkElems();
          }
          root.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
          root.dispatchEvent(
            new CustomEvent('ir-v5:collection:append', {
              bubbles: true,
              detail: { addedCount: addedCount, url: nextUrl }
            })
          );
        })
        .catch(function () {
          window.location.assign(nextUrl);
        })
        .then(function () {
          delete target.dataset.irV5LoadMoreLoading;
          setLoadMoreLoading(target, false);
        });
    });

    observeInfiniteLink();
    window.addEventListener('scroll', queueAutoLoad, { passive: true });
    window.addEventListener('resize', queueAutoLoad);
  }

  function setup(root) {
    if (!root || root.dataset.irV5CollectionReady === 'true') return;

    root.dataset.irV5CollectionReady = 'true';
    setupLoadMore(root);
    setupSort(root);
    setupSidebar(root);
    setupCollectionHoverImages(root);
  }

  function init(scope) {
    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) setup(scope);
    if (scope && scope.querySelectorAll) scope.querySelectorAll(ROOT_SELECTOR).forEach(setup);
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
